import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Options, LabelType } from 'ng5-slider';
import { Subscription, Observable } from 'rxjs';

@Component({
  selector: 'app-trafic',
  templateUrl: './trafic.component.html',
  styleUrls: ['./trafic.component.css']
})
export class TraficComponent implements OnInit{

  private updateSubscription: Subscription;

  @Input() events: Observable<void>;


  @Output() trafficEmitter = new EventEmitter<string>(); // Emisor d'events cap a component pare

  consultarTransit = false; // Indica si l'usuari vol consultar o no el trànsit
  showOptions = false; // Indica si l'usuari vol mostrar les opcions de ltrànsit o no
  modes = ['Trànsit en directe','Trànsit en previsió']; // Modes de trànsit disponibles
  selectedMode = this.modes[0]; // Mode de trànsit seleccionat 
  timeValue: number; // Valor entre 0 i 95 que indica una hora del dia, múltiple de 15 minuts (00:00 = 0,00:15 = 1,00:30 = 2,00:45 = 3, 01:00 = 4, ... , 23:45 = 95)
  horaInicialitzacio; // Hora en que s'ha iniciat l'aplicació
  date: Date; // Data en que s'està fent la previsió
  formattedDate: string; // Data actual amb format dd/mm/yyyy
  minDate: Date; // Data mínima per la qual es pot fer previsió
  maxDate: Date; // Data màxima per la qual es pot fer previsió
  lastUpdate: number; // Moment en que s'ha fet la darrera actualització de les capes
  /*
  ngOnChanges(changes: SimpleChanges) {
    console.log("canvis al input de TraficComponent");
    console.log(changes);
  }
*/
  options: Options = { // Propietats de l'slider per escollir hora del dia per fer la previsió
    floor: 0,
    ceil: 95,
    showSelectionBar: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          var hora = this.numberToTime(value);
          return '<div id="timeLabel" style="font-weight: 700; text-align: center; letter-spacing: 0; color: #4B4949; opacity: 1; margin-right: 2px">' + hora + '</div>';
        default:
          return '';
      }
    }
  };

  /**
   * Retorna una hora en el format "hh:mm" donat value, que representa una hora del dia 
   * @param value Value >= 0 i <= 96. Cada número representa una hora del dia múltiple de 15 minuts (00:00 = 0,00:15 = 1,00:30 = 2,00:45 = 3, 01:00 = 4, ... , 23:45 = 95)
   */
  numberToTime(value: number): string{
    var hora = Math.trunc(value/96*24);
    var minuts = (value % 4)*15;
    var horaRes = hora.toString();
    var minRes = minuts.toString();
    if(hora <= 9) horaRes = "0" + horaRes;
    if(minuts <= 0) minRes = minRes + "0";
    return horaRes + ":" + minRes;
  }

  /**
   * Retorna un valor >= 0 i <= 96. Cada número representa una hora del dia múltiple de 15 minuts (00:00 = 0,00:15 = 1,00:30 = 2,00:45 = 3, 01:00 = 4, ... , 23:45 = 95)
   * @param time Hora del dia en format "hh:mm"
   */
  timeToNumber(time: string): number{
    var horaString = time.split(':')[0];
    var minutsString = time.split(':')[1];
    var hora = Math.trunc(parseInt(horaString) * 96 / 24);
    var minuts = 4 / (60 / parseInt(minutsString));
    return hora + minuts;
  }

  /**
   * Compara dues dates i retorna cert si tenen el mateix dia, mes i hora
   */
  sameDate(date1: Date, date2: Date): boolean{
    return date1.getFullYear() === date2.getFullYear() 
          && date1.getMonth() === date2.getMonth() 
          && date1.getDate() === date2.getDate();

  }


  /**
   * Actualitza la data i l'hora segons l'input de l'usuari. També canvia els límits de l'slider
   * @param event La nova data entrada per l'usuari
   */
  changeDate(event){
    this.date = new Date(event);
    if(!this.sameDate(this.date,this.minDate) && !this.sameDate(this.date,this.maxDate)){
      this.setNewMin(0);
      this.setNewMax(95);
    }
    else if(this.sameDate(this.date,this.minDate)){ //Mínim: Quart d'hora següent més proper a l'hora actual
      this.setNewMin(this.horaInicialitzacio);
      this.setNewMax(95);
      if(this.timeValue < this.horaInicialitzacio) this.timeValue = this.horaInicialitzacio;
    }
    else if(this.sameDate(this.date,this.maxDate)){ //Màxim: Quart d'hora anterior més proper a l'hora actual - 1 de l'any següent
      this.setNewMin(0);
      this.setNewMax(this.horaInicialitzacio-5); 
      if(this.timeValue > this.horaInicialitzacio) this.timeValue = this.horaInicialitzacio-5;
    }
    var hora = this.numberToTime(this.timeValue).split(':');
    this.date.setHours(parseInt(hora[0]),parseInt(hora[1])); 
    var dateZulu = new Date(this.date);
    dateZulu.setHours(dateZulu.getHours() + 1);
    this.trafficEmitter.emit(dateZulu.toISOString()); //toISOString fa servir hora Zulu, -1 hora local
    
  }

  /**
   * Actualitza l'hora de l'objecte date que conté la data del component. S'activa quan es fan canvis al slider
   */
  updateTime(){
    var hora = this.numberToTime(this.timeValue).split(':');
    this.date.setHours(parseInt(hora[0]),parseInt(hora[1])); 
    var dateZulu = new Date(this.date);
    dateZulu.setHours(dateZulu.getHours() + 1);
    this.trafficEmitter.emit(dateZulu.toISOString()); //toISOString fa servir hora Zulu, -1 hora local
  }


  /**
   * Emet l'event cap al component pare
   * @param toggle indica si l'event a emetre és activar/desactivar la capa de trànsit
   */
  emitEvent(toggle: boolean) {
    if(toggle){
      this.consultarTransit = !this.consultarTransit;
      this.trafficEmitter.emit('toggle');
    }
    
  }

  /**
   * Mostra o amaga les opcions del tràfic
   */
  toggleOptions() {
    this.showOptions = !this.showOptions;
  }

  /**
   * Canvia el mode de trànsit seleccionat
   */
  onSelect(){
    if(this.selectedMode === 'Trànsit en previsió') this.selectedMode = 'Trànsit en directe';
    else if(this.selectedMode === 'Trànsit en directe') this.selectedMode = 'Trànsit en previsió';
    this.trafficEmitter.emit(this.selectedMode + '|' + this.date.toISOString());
     /* 
    if(this.consultarTransit){
    if(this.selectedMode === 'Trànsit en previsió')
        this.trafficEmitter.emit(this.selectedMode + '|' + this.date.toISOString());
      else
        this.trafficEmitter.emit(this.selectedMode);
    }*/
  }


  /**
   * Inicialitza la data pel dia d'avui i l'hora actual determinada per la seva inicialització (+15 minuts hora actual)
   */
  initDate(){
    this.date = new Date();
    var hora = this.numberToTime(this.timeValue).split(':');
    this.date.setHours(parseInt(hora[0]),parseInt(hora[1]),0,0);
  }

  /**
   * Inicialitza l'hora per la previsió de trànsit, 15 minuts per davant de l'hora actual
   */
  initTime(){
    this.lastUpdate = Date.now();
    var hores;
    var minuts; 
    var dateTime = new Date().toTimeString().split(':');

    //sumem 15 minuts per previsió
    hores = parseInt(dateTime[0]);
    minuts = parseInt(dateTime[1]) + 15;
    if(minuts >= 60){
      hores++;
      minuts = 0;
    }
    else{
      minuts = Math.trunc(minuts/15);
      minuts *= 15;
    }

    this.timeValue = this.timeToNumber(hores + ':' + minuts);
  }

  /**
   * Canvia el mínim valor que pot obtenir el slider per escollir l'hora
   */
  setNewMin(newMin: number): void {
    const newOptions: Options = Object.assign({}, this.options);
    newOptions.minLimit = newMin;
    this.options = newOptions;
  }

  /**
   * Canvia el màxim valor que pot obtenir el slider per escollir l'hora
   */
  setNewMax(newMax: number): void {
    const newOptions: Options = Object.assign({}, this.options);
    newOptions.maxLimit = newMax;
    this.options = newOptions;
  }

  constructor() {
  }

  ngOnInit() {
    this.formattedDate = new Date().toISOString().split('T')[0];
    this.minDate = new Date();
    this.maxDate = new Date(this.minDate); 
    this.maxDate.setFullYear(this.maxDate.getFullYear() + 1);
    this.initTime();
    this.initDate();
    this.horaInicialitzacio = this.timeValue;
    this.setNewMin(this.timeValue);

    this.updateSubscription = this.events.subscribe(() =>{
      this.lastUpdate = Date.now();
    });
  }

}
